import React from 'react';
import { StarIcon, PlusIcon, MinusIcon, RefreshCwIcon } from 'lucide-react';
interface SidebarUnitsPanelProps {
  activeCategory: string;
  activeSubcategory: string;
  filterUnits: (units: any[]) => any[];
  cabinetUnits: Record<string, any[]>;
  handleUnitSelect: (unit: any) => void;
  toggleFilter: (filterId: string) => void;
  toggleView: (view: 'all' | 'favorites') => void;
  showOnlyFavorites: boolean;
  getGroupedFilterOptions: () => {
    typeOptions: any[];
    featureOptions: any[];
  };
  activeFilters: string[];
  toggleFavorite: (unitId: string, event: React.MouseEvent) => void;
  favorites: string[];
  adjustUnitWidth: (unitId: string, adjustment: number, event: React.MouseEvent) => void;
  setCustomWidth: (unitId: string, width: number, event: React.MouseEvent) => void;
  customWidths: Record<string, number>;
}
export function SidebarUnitsPanel({
  activeCategory,
  activeSubcategory,
  filterUnits,
  cabinetUnits,
  handleUnitSelect,
  toggleFilter,
  toggleView,
  showOnlyFavorites,
  getGroupedFilterOptions,
  activeFilters,
  toggleFavorite,
  favorites,
  adjustUnitWidth,
  setCustomWidth,
  customWidths
}: SidebarUnitsPanelProps) {
  if (activeCategory !== 'carpentry') return null;
  return <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1050">
      {/* Filter options - improved layout */}
      <div className="px-3 py-3 border-b border-gray-200 dark:border-darkbg-border" data-id="element-1051">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1052">
          Filter by Type
        </h4>
        <div className="flex gap-2 mb-3" data-id="element-1053">
          <button className={`px-3 py-1.5 text-sm font-medium rounded-md flex-1 ${!showOnlyFavorites ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-accent-blue' : 'bg-gray-100 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => toggleView('all')} data-id="element-1054">
            All
          </button>
          <button className={`px-3 py-1.5 text-sm font-medium rounded-md flex-1 flex items-center justify-center ${showOnlyFavorites ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-accent-blue' : 'bg-gray-100 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => toggleView('favorites')} data-id="element-1055">
            <StarIcon className="h-3 w-3 mr-1" data-id="element-1056" />
            Favorites
          </button>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-1057">
          {getGroupedFilterOptions().typeOptions.map(option => <button key={option.id} className={`px-3 py-1.5 text-sm font-medium rounded-md ${activeFilters.includes(option.id) ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-accent-blue' : 'bg-gray-100 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => toggleFilter(option.id)} data-id="element-1058">
              {option.name}
            </button>)}
        </div>
        {(getGroupedFilterOptions().featureOptions.length > 0 || true) && <div className="flex flex-wrap gap-2 mt-2" data-id="element-1059">
            {getGroupedFilterOptions().featureOptions.map(option => <button key={option.id} className={`px-3 py-1.5 text-sm font-medium rounded-md ${activeFilters.includes(option.id) ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-accent-blue' : 'bg-gray-100 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => toggleFilter(option.id)} data-id="element-1060">
                {option.name}
              </button>)}
            <button className={`px-3 py-1.5 text-sm font-medium rounded-md ${activeFilters.includes('finishing-elements') ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-accent-blue' : 'bg-gray-100 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => toggleFilter('finishing-elements')} data-id="element-1061">
              Finishing Elements
            </button>
          </div>}
      </div>
      {/* Cabinet units grid */}
      <div className="flex-1 overflow-y-auto p-4" data-id="element-1062">
        <div className="grid grid-cols-2 gap-4" data-id="element-1063">
          {filterUnits(cabinetUnits[activeSubcategory]).map(unit => {
          const unitWidth = customWidths[unit.id] || unit.width;
          const isFavorite = favorites.includes(unit.id);
          return <div key={unit.id} className="border border-gray-200 rounded-lg overflow-hidden bg-white dark:bg-darkbg-secondary dark:border-darkbg-border cursor-pointer shadow-sm hover:shadow-md transition-shadow" onClick={() => handleUnitSelect(unit)} data-id="element-1064">
                <div className="relative" data-id="element-1065">
                  <img src={unit.image} alt={unit.name} className="w-full h-32 object-cover" data-id="element-1066" />
                  <button className={`absolute top-2 right-2 p-1.5 rounded-full ${isFavorite ? 'bg-yellow-400 text-white' : 'bg-white bg-opacity-80 text-gray-500 hover:text-yellow-500 dark:bg-darkbg-secondary dark:text-gray-300'}`} onClick={e => toggleFavorite(unit.id, e)} data-id="element-1067">
                    <StarIcon className={`h-4 w-4 ${isFavorite ? 'fill-current' : ''}`} data-id="element-1068" />
                  </button>
                </div>
                <div className="p-3" data-id="element-1069">
                  <div className="flex items-center justify-center mt-1" data-id="element-1070">
                    <div className="flex flex-col items-center" data-id="element-1071">
                      <div className="flex items-center mb-1" data-id="element-1072">
                        <button className="p-1.5 bg-gray-100 text-gray-600 rounded-l-md border border-gray-300 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-gray-400" onClick={e => adjustUnitWidth(unit.id, -10, e)} title="Decrease by 10" data-id="element-1073">
                          <div className="flex items-center" data-id="element-1074">
                            <MinusIcon className="h-4 w-4" data-id="element-1075" />
                            <span className="text-xs ml-0.5" data-id="element-1076">10</span>
                          </div>
                        </button>
                        <button className="p-1.5 bg-gray-100 text-gray-600 border-t border-b border-gray-300 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-gray-400" onClick={e => adjustUnitWidth(unit.id, 10, e)} title="Increase by 10" data-id="element-1077">
                          <div className="flex items-center" data-id="element-1078">
                            <PlusIcon className="h-4 w-4" data-id="element-1079" />
                            <span className="text-xs ml-0.5" data-id="element-1080">10</span>
                          </div>
                        </button>
                        <button className="p-1.5 bg-gray-100 text-gray-600 rounded-r-md border border-gray-300 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-gray-400" onClick={e => setCustomWidth(unit.id, 60, e)} title="Reset to 60cm" data-id="element-1081">
                          <RefreshCwIcon className="h-4 w-4" data-id="element-1082" />
                        </button>
                      </div>
                      <div className="flex items-center" data-id="element-1083">
                        <button className="p-1.5 bg-gray-100 text-gray-600 rounded-l-md border border-gray-300 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-gray-400" onClick={e => adjustUnitWidth(unit.id, -1, e)} title="Decrease by 1" data-id="element-1084">
                          <MinusIcon className="h-4 w-4" data-id="element-1085" />
                        </button>
                        <input type="number" value={unitWidth} onChange={e => setCustomWidth(unit.id, parseInt(e.target.value) || 30, e)} onClick={e => e.stopPropagation()} className="border-t border-b border-gray-300 py-1.5 px-2 text-center w-16 text-sm dark:bg-darkbg-primary dark:border-darkbg-border dark:text-white appearance-none" style={{
                      WebkitAppearance: 'none',
                      MozAppearance: 'textfield'
                    }} data-id="element-1086" />
                        <button className="p-1.5 bg-gray-100 text-gray-600 rounded-r-md border border-gray-300 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-gray-400" onClick={e => adjustUnitWidth(unit.id, 1, e)} title="Increase by 1" data-id="element-1087">
                          <PlusIcon className="h-4 w-4" data-id="element-1088" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
        {/* Show message if no units match the filter */}
        {filterUnits(cabinetUnits[activeSubcategory]).length === 0 && <div className="text-center py-8" data-id="element-1089">
            <p className="text-base text-gray-500 dark:text-gray-400" data-id="element-1090">
              No cabinets match the current filters.
            </p>
            <button className="mt-3 text-sm text-blue-600 hover:text-blue-800 dark:text-accent-blue dark:hover:text-blue-400" onClick={() => {
          // Clear filters
        }} data-id="element-1091">
              Clear filters
            </button>
          </div>}
      </div>
    </div>;
}